import { getIsoCountry } from '../utils/locale'

const CMP_REGULATIONS_KEY_DEFAULT = 'GDPR'
const CMP_REGULATIONS_KEY_CH = 'DSGLPD'

const PRIVACY_URLS: Record<string, string> = {
  'de-DE': 'https://www.fielmann.de/datenschutz/',
  'de-AT': 'https://www.fielmann.at/datenschutz/',
  'de-CH': 'https://www.fielmann.ch/datenschutz/',
  'fr-CH': 'https://fr.fielmann.ch/protectiondesdonnees/',
  'it-CH': 'https://it.fielmann.ch/protezionedeidati/',
  'pl-PL': 'https://www.fielmann.pl/ochronadanych/',
  'cs-CZ': 'https://www.fielmann.cz/ochrana-udaju/',
  'it-IT': 'https://www.fielmann.it/protezionedeidati/',
  'de-IT': 'https://de.fielmann.it/datenschutz/',
}

const IMPRINT_URLS: Record<string, string> = {
  'de-DE': 'https://www.fielmann.de/impressum/',
  'de-AT': 'https://www.fielmann.at/impressum/',
  'de-CH': 'https://www.fielmann.ch/impressum/',
  'fr-CH': 'https://fr.fielmann.ch/mentions-legales/',
  'it-CH': 'https://it.fielmann.ch/datisocietari/',
  'pl-PL': 'https://www.fielmann.pl/impressum/',
  'cs-CZ': 'https://www.fielmann.cz/impresum/',
  'it-IT': 'https://www.fielmann.it/datisocietari/',
  'de-IT': 'https://de.fielmann.it/impressum/',
}

export default defineNuxtPlugin({
  name: 'consentmanager',
  setup() {
    const runtimeConfig = useRuntimeConfig()
    const { $currentShop } = useNuxtApp()
    const countryCode = getIsoCountry($currentShop.locale)
    const locale = getNormalizedLocale($currentShop.locale)
    const cmp = runtimeConfig.public.cmp
    const route = useRoute()

    if (!cmp?.cdid || Boolean(getQueryParam(route?.query, 'storeMode'))) {
      return
    }

    const inlineScript = `
window.cmp_regulationkey = "${countryCode === 'CH' ? CMP_REGULATIONS_KEY_CH : CMP_REGULATIONS_KEY_DEFAULT}";
window.cmp_privacyurl = "${PRIVACY_URLS[locale]}";
window.cmp_imprinturl = "${IMPRINT_URLS[locale]}";
`

    useHead(() => ({
      link: [
        {
          key: 'cmp-preconnect',
          rel: 'preconnect',
          crossorigin: '',
          href: 'https://cdn.consentmanager.net',
        },
      ],
      script: [
        {
          innerHTML: inlineScript,
          key: 'cmp-localization',
          type: 'text/javascript',
        },
        {
          src: 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js',
          type: 'text/javascript',
          key: 'cmp-script',
          body: true,
          'data-cmp-ab': cmp?.ab ?? 1,
          'data-cmp-cdid': cmp?.cdid,
          'data-cmp-host': cmp?.host ?? 'c.delivery.consentmanager.net',
          'data-cmp-cdn': cmp?.cdn ?? 'cdn.consentmanager.net',
          'data-cmp-codesrc': cmp?.codesrc ?? 0,
        },
      ],
    }))
  },
})
